module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-22@2x-bdfdafcc6c46ab2441d3f57e1646c247.png";